module.exports = __webpack_public_path__ + "img/new_sports.e15c4ee4.svg";